module.exports = __webpack_public_path__ + "01a0b3129b0de3620acec848319dedc9.svg";